module.exports = __webpack_public_path__ + "static/media/error.4e8cea1f.svg";